// extracted by mini-css-extract-plugin
export var footer = "_pj-0";
export var inherit = "_pj-1";
export var input = "_pj-2";
export var modalContent = "_pj-3";
export var quillEditor = "_pj-4";
export var subtitle = "_pj-5";